import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {WebapiService} from '../../webapi.service';
import {AuthService} from '../../auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  formData: any={};

  constructor(private webapiservice:WebapiService,
    private router:Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit() {
  }

  // doLogin(data:any){
  //  this.webapiservice.doLogin(data).subscribe((res:any)=>{
  //   if(res.status == "ok"){
  //     // Use AuthService to set token
  //     this.authService.setToken(res.token);
      
  //     // Store user data in session
  //     sessionStorage.setItem('loginId',res?.user?._id);
  //     sessionStorage.setItem('name',res?.user?.name);
  //     sessionStorage.setItem('type',res?.user?.type);
      
  //     if(res?.user?.team){
  //       this.getTeamById(res?.user?.team);
  //     }
  //     if(res?.user?.type == 6 || res?.user?.type == 7){
  //       sessionStorage.setItem('assignProcess',res?.user?.assign_process);
  //       sessionStorage.setItem('addedId',res?.user?.addedId);
  //     }
  //     if(res?.user?._id == '670654c31539eee3796d1872' || res?.user?.addedId == '670654c31539eee3796d1872'){
  //       this.trackUser(res?.user?._id,"login");
  //     }
  //     this.router.navigate(['/dashboard']);
  //   }
  //   else{
  //     alert(res.msg);
  //   }
  //  },(error:HttpErrorResponse)=>{
  //   console.log(error.error);
  //   // Clear form data
  //   this.formData.email="";
  //   this.formData.password="";
  //  })

  // }

  doLogin(data: any) {
    this.webapiservice.doLogin(data).subscribe({
      next: (res: any) => {
        if (res.status === 'ok') {
          // Use AuthService to set token
          this.authService.setToken(res.token);

          console.log(res);
  
          // Store user data — localStorage survives page refresh; sessionStorage does not
          localStorage.setItem('loginId', res?.user?._id);
          localStorage.setItem('name', res?.user?.name);
          localStorage.setItem('type', String(res?.user?.type));
          // Keep sessionStorage in sync for any legacy reads
          sessionStorage.setItem('loginId', res?.user?._id);
          sessionStorage.setItem('name', res?.user?.name);
          sessionStorage.setItem('type', res?.user?.type);
  
          if (res?.user?.team) {
            this.getTeamById(res?.user?.team);
          }
  
          if (res?.user?.type == 6 || res?.user?.type == 7) {
            localStorage.setItem('assignProcess', res?.user?.assign_process);
            localStorage.setItem('addedId', res?.user?.addedId);
            sessionStorage.setItem('assignProcess', res?.user?.assign_process);
            sessionStorage.setItem('addedId', res?.user?.addedId);
          }
  
          if (
            res?.user?._id === '670654c31539eee3796d1872' ||
            res?.user?.addedId === '670654c31539eee3796d1872'
          ) {
            this.trackUser(res?.user?._id, 'login');
          }
  
          this.router.navigate(['/dashboard']);
        } else {
          alert(res.msg || 'Login failed. Please try again.');
        }
      },
      error: (error: any) => {
        // Handle function-wrapped error objects from interceptor
        if (typeof error === 'function') {
          try {
            const errorObj = error();
            if (errorObj && errorObj.error && errorObj.error.msg) {
              alert(errorObj.error.msg);
            } else if (errorObj && errorObj.status === 429) {
              alert('Too many login attempts. Please try again later.');
            } else if (errorObj && errorObj.status === 401) {
              alert('Invalid username or password');
            } else {
              alert('Login failed. Please try again.');
            }
          } catch (e) {
            alert('Login failed. Please try again.');
          }
        }
        // Handle regular error objects
        else if (error.error && error.error.msg) {
          alert(error.error.msg);
        } else if (error.error && typeof error.error === 'string') {
          alert(error.error);
        } else if (error.status === 401) {
          alert('Invalid username or password');
        } else if (error.status === 429) {
          alert('Too many login attempts. Please try again later.');
        } else {
          alert('Login failed. Please try again.');
        }
        
        // Clear form data
        this.formData.email = '';
        this.formData.password = '';
      },
    });
  }
  

  trackUser(empId:any,event:any){
    let val = {
      employeeId:empId,
      eventType:event,
      eventDescription:'User Logs in to the system'

    }
    this.webapiservice.trackUser(val).subscribe((res:any)=>{
       console.log(res);
       
    });
  }

  getTeamById(id:any){
    this.webapiservice.getTeamById(id).subscribe((res:any)=>{
       localStorage.setItem('teamName', res.team.name);   // survives page refresh
       sessionStorage.setItem('teamName', res.team.name); // keep in sync
    });
  }
}
